<template>
    <div class="ah-file-icon" @click="handleClick">
        <img class="img" src="@/assets/img/file-icon.svg" />
        <div class="ext">{{ extText }}</div>
    </div>
</template>
<script>
export default {
    name: 'ah-file-icon',
    props: {
        ext: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: 'normal',
        },
        url: {
            type: String,
            default: null,
        },
    },

    data() {
        return {};
    },

    computed: {
        extText() {
            if (this.ext) {
                return this.ext;
            }
            if (this.url) {
                return this.url
                    .split('.')
                    .pop()
                    .toLowerCase();
            }

            return null;
        },
    },

    methods: {
        handleClick() {
            if (this.url) {
                window.open(this.url, '_blank', 'toolbar=no, width=1300, height=900');
            }
        },
    },
};
</script>
<style lang="scss">
.ah-file-icon {
    position: relative;
    width: 80px;
    margin: 0 auto;
    cursor: pointer;

    .img {
        width: 80px;
    }

    .ext {
        position: absolute;
        bottom: 25px;
        right: 5px;
        width: 50px;
        padding: 2px 0;
        line-height: 100%;
        text-align: center;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12pt;
        color: #ccc;
        border: 2px solid #ccc;
        background-color: #fff;
        border-radius: 6px;
    }

    &.large {
        width: 120px;

        .img {
            width: 120px;
        }

        .ext {
            position: absolute;
            bottom: 35px;
            right: 5px;
            width: 60px;
            padding: 2px 0;
            font-size: 13pt;
            border: 3px solid #ccc;
        }
    }
}
</style>
